export const headerData = [
  {
    key: 1,
    title: 'トップ',
    icon: require('@/assets/images/v2/icon-topping.svg'),
    value: 'topping',
    name: 'rank_v2'
  },
  {
    key: 2,
    title: 'ショッピングカート',
    icon: require('@/assets/images/v2/icon-cart.svg'),
    value: 'cart',
    name: 'cart_v2'
  },
  {
    key: 3,
    title: '注文履歴',
    icon: require('@/assets/images/v2/icon-history.svg'),
    value: 'orderHistory',
    name: 'order_history_v2'
  },
  // {
  //   key: 4,
  //   title: '登録情報',
  //   icon: require('@/assets/images/v2/icon-info.svg'),
  //   value: 'mypage',
  //   name: 'my_page_v2'
  // },
  {
    key: 5,
    title: 'ホーム画面に追加',
    icon: require('@/assets/images/v2/icon-add-shortcut.svg'),
    value: 'shortcut',
    name: 'add-shortcut'
  }
]

export const staticScreen = [
  {
    key: 6,
    title: 'プライバシーポリシー',
    icon: require('@/assets/images/v2/icon-right.svg'),
    name: 'privacypolicy_v2'
  },
  {
    key: 7,
    title: '特商法に基づく表記',
    icon: require('@/assets/images/v2/icon-right.svg'),
    name: 'store_detail_two_v2'
  }
]
